import axios from "axios";
import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Collapse,
  Container,
  Row,
  Tab,
  Nav,
} from "react-bootstrap";
import { NumericFormat } from "react-number-format";

function TradeDashboard() {
  const [tradeData, setTradeData] = useState([]);
  const [openDetails, setOpenDetails] = useState({});
  const stdPortNo = ["1764453"];
  const demoPort = ["7482989"];
  const [exchangeRate, setExchangeRate] = useState(null);

  // ฟังก์ชันดึงข้อมูลจาก fetch_trade_status.php ทุก ๆ 5 วินาที
  useEffect(() => {
    const API_URL = `https://v6.exchangerate-api.com/v6/df37c1874690c7fab585586b/latest/USD`;
    const fetchExchangeRate = async () => {
      try {
        const response = await fetch(API_URL);
        const data = await response.json();

        if (data.result === "success") {
          setExchangeRate(data.conversion_rates.THB);
        } else {
          console.error("Error fetching exchange rates:", data.error);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchExchangeRate();

    const fetchTradeData = () => {
      axios
        .get("https://gold-ea.chabalu.com/fetch_trade_status.php")
        .then((response) => setTradeData(response.data))
        .catch((error) => console.error("Error loading trade status:", error));
    };

    fetchTradeData(); // เรียกครั้งแรกทันที
    const interval = setInterval(fetchTradeData, 5000); // อัปเดตทุก 5 วินาที
    return () => clearInterval(interval); // ล้าง interval เมื่อ component ถูก unmount
  }, []);

  const toggleDetails = (accountNo) => {
    setOpenDetails((prevState) => ({
      ...prevState,
      [accountNo]: !prevState[accountNo],
    }));
  };

  const getShortName = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase())
      .join("");
  };

  const realisedProfit = (account) => {
    let totalBalance =
      parseFloat(account.TotalProfit) + parseFloat(account.TotalDeposit);
    let totalProfit = parseFloat(account.TotalProfit);

    if (!stdPortNo.includes(account.AccountNo)) {
      totalBalance = totalBalance / 100;
      totalProfit = totalProfit / 100;
    }

    return (
      <>
        <strong className="me-2">Balance:</strong>
        <NumericFormat
          displayType="text"
          value={totalBalance}
          prefix="$"
          thousandSeparator=","
          decimalScale={2}
        />
        <span className="text-success">
          <NumericFormat
            displayType="text"
            value={totalProfit}
            prefix="(+$"
            suffix=")"
            thousandSeparator=","
            decimalScale={2}
          />
        </span>
      </>
    );
  };

  const showCurrency = (accountNo, value) => {
    if (!stdPortNo.includes(accountNo)) {
      return parseFloat(value / 100).toFixed(2);
    }

    return parseFloat(value).toFixed(2);
  };

  // จัดกลุ่ม tradeData ตาม AccountName และคำนวณ Total Profit
  const groupedData = tradeData.reduce((groups, account) => {
    const {
      AccountName,
      ProfitToday,
      ProfitYesterday,
      ProfitCurrentMonth,
      AccountNo,
      PointsToWipeout,
      TotalDeposit,
      TotalProfit,
    } = account;
    const shortName = getShortName(AccountName);
    if (!groups[shortName]) {
      groups[shortName] = {
        accounts: [],
        totalProfitToday: 0,
        totalProfitYesterday: 0,
        totalProfitCurrentMonth: 0,
        totalProfit: 0,
        totalBalance: 0,
        warning: 0,
        danger: 0,
      };
    }

    groups[shortName].accounts.push(account);

    if (!demoPort.includes(AccountNo)) {
      if (!stdPortNo.includes(AccountNo)) {
        groups[shortName].totalProfitToday += parseFloat(ProfitToday / 100);
        groups[shortName].totalProfitYesterday += parseFloat(
          ProfitYesterday / 100
        );
        groups[shortName].totalProfitCurrentMonth += parseFloat(
          ProfitCurrentMonth / 100
        );

        groups[shortName].totalProfit += parseFloat(TotalProfit / 100);
        groups[shortName].totalBalance += parseFloat(TotalDeposit / 100);
      } else {
        groups[shortName].totalProfitToday += parseFloat(ProfitToday);
        groups[shortName].totalProfitYesterday += parseFloat(ProfitYesterday);
        groups[shortName].totalProfitCurrentMonth +=
          parseFloat(ProfitCurrentMonth);

        groups[shortName].totalProfit += parseFloat(TotalProfit);
        groups[shortName].totalBalance += parseFloat(TotalDeposit);
      }
    }

    if (PointsToWipeout < 10000) {
      groups[shortName].danger++;
    } else if (PointsToWipeout < 15000) {
      groups[shortName].warning++;
    }

    return groups;
  }, {});

  return (
    <Container className="mt-5">
      <h1 className="mb-4">Dashboard - Trade Status</h1>
      <Tab.Container id="left-tabs-example" defaultActiveKey="content-0">
        <Row>
          <Col sm={3}>
            <Card className="mb-4">
              <Card.Header className="d-flex justify-content-between align-items-center mb-3">
                <Card.Title>Port</Card.Title>
              </Card.Header>
              <Card.Body>
                <Nav variant="pills" className="flex-column">
                  {Object.keys(groupedData).map((accountName, idx) => (
                    <Nav.Item key={`menu-${idx}`}>
                      <Nav.Link eventKey={`content-${idx}`}>
                        <div className="d-flex justify-content-between align-items-center">
                          {accountName}
                          <div>
                            <span class="badge bg-secondary">
                              <NumericFormat
                                displayType="text"
                                value={
                                  groupedData[accountName].totalProfitToday
                                }
                                prefix="$"
                                thousandSeparator=","
                                decimalScale={2}
                              />
                            </span>
                            <span class="badge bg-warning">
                              {groupedData[accountName].warning}
                            </span>
                            <span class="badge bg-danger">
                              {groupedData[accountName].danger}
                            </span>
                          </div>
                        </div>
                      </Nav.Link>
                    </Nav.Item>
                  ))}
                </Nav>
              </Card.Body>
            </Card>
          </Col>
          <Col sm={9}>
            <Tab.Content>
              {Object.keys(groupedData).map((accountName, idx) => (
                <Tab.Pane
                  key={`menu-${accountName}-${idx}`}
                  eventKey={`content-${idx}`}
                >
                  <Card>
                    <Card.Header className="d-flex justify-content-between align-items-center mb-3">
                      <Card.Title>{accountName}</Card.Title>
                      <h5 className="p-0 m-0">
                        <span class="badge bg-secondary">
                          <NumericFormat
                            displayType="text"
                            value={groupedData[accountName].totalProfitToday}
                            prefix="Profit Today: $"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                          <NumericFormat
                            displayType="text"
                            value={
                              groupedData[accountName].totalProfitToday *
                              exchangeRate
                            }
                            prefix=" (~฿"
                            suffix=")"
                            thousandSeparator=","
                            decimalScale={2}
                          />
                        </span>
                      </h5>
                    </Card.Header>
                    <Card.Body>
                      <Card className={`shadow-sm mb-4`}>
                        <Card.Header className="d-flex justify-content-between align-items-center mb-3">
                          <Card.Title>Summary</Card.Title>
                        </Card.Header>
                        <Card.Body>
                          <p>
                            <strong className="me-2">Total Yield:</strong>
                            <NumericFormat
                              displayType="text"
                              value={
                                (groupedData[accountName].totalProfit /
                                  groupedData[accountName].totalBalance) *
                                100
                              }
                              suffix=" %"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </p>
                          <p>
                            <strong className="me-2">USD/THB Rate:</strong>
                            <NumericFormat
                              displayType="text"
                              value={exchangeRate}
                              thousandSeparator=","
                              prefix="฿"
                              decimalScale={2}
                            />
                          </p>
                          <p>
                            <strong className="me-2">
                              Total Profit Today:
                            </strong>
                            <NumericFormat
                              displayType="text"
                              value={groupedData[accountName].totalProfitToday}
                              prefix="$"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalProfitToday *
                                exchangeRate
                              }
                              prefix=" (~฿"
                              suffix=")"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </p>
                          <p>
                            <strong className="me-2">
                              Total Profit Yesterday:
                            </strong>
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalProfitYesterday
                              }
                              prefix="$"
                              suffix=" "
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            (
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalProfitYesterday *
                                exchangeRate
                              }
                              suffix=" บาท"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            )
                          </p>
                          <p>
                            <strong className="me-2">
                              Total Profit Current Month:
                            </strong>
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalProfitCurrentMonth
                              }
                              prefix="$"
                              suffix=" "
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            (
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName]
                                  .totalProfitCurrentMonth * exchangeRate
                              }
                              suffix=" บาท"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            )
                          </p>
                          <p>
                            <strong className="me-2">Total Deposit:</strong>
                            <NumericFormat
                              displayType="text"
                              value={groupedData[accountName].totalBalance}
                              prefix="$"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalBalance *
                                exchangeRate
                              }
                              prefix=" (~฿"
                              suffix=")"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </p>
                          <p>
                            <strong className="me-2">Total Profit:</strong>
                            <NumericFormat
                              displayType="text"
                              value={groupedData[accountName].totalProfit}
                              prefix="$"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                            <NumericFormat
                              displayType="text"
                              value={
                                groupedData[accountName].totalProfit *
                                exchangeRate
                              }
                              prefix=" (~฿"
                              suffix=")"
                              thousandSeparator=","
                              decimalScale={2}
                            />
                          </p>
                        </Card.Body>
                      </Card>
                      <Row>
                        {groupedData[accountName].accounts.map(
                          (account, index) => {
                            const isDanger =
                              parseFloat(account.PointsToWipeout) < 10000;
                            const isWarning =
                              parseFloat(account.PointsToWipeout) < 15000 &&
                              !isDanger;
                            const customClassCard = isDanger
                              ? "text-white bg-danger"
                              : isWarning
                              ? "text-dark bg-warning"
                              : "";
                            const customTextDisplay =
                              isDanger || isWarning
                                ? "text-white"
                                : "text-primary";

                            return (
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="mb-3"
                                key={index}
                              >
                                <Card
                                  className={`${customClassCard} shadow-sm`}
                                >
                                  <Card.Header className="d-flex justify-content-between align-items-center mb-3">
                                    <Card.Title>
                                      Port: {account.AccountNo}
                                      {demoPort.includes(account.AccountNo)
                                        ? " [DEMO]"
                                        : ""}
                                    </Card.Title>
                                    <div>
                                      <span class="badge bg-primary me-1">
                                        <NumericFormat
                                          displayType="text"
                                          value={
                                            (account.TotalProfit /
                                              account.TotalDeposit) *
                                            100
                                          }
                                          suffix="%"
                                          thousandSeparator=","
                                          decimalScale={2}
                                        />
                                      </span>
                                      <span class="badge bg-success ">
                                        {account.TotalOrder}/
                                        {account.MaxOrder === 0
                                          ? "Unlimit"
                                          : account.MaxOrder}
                                      </span>
                                    </div>
                                  </Card.Header>
                                  <Card.Body>
                                    <p>{realisedProfit(account)}</p>
                                    <p>
                                      <strong className="me-2">
                                        Current Profit:
                                      </strong>
                                      $
                                      {showCurrency(
                                        account.AccountNo,
                                        account.CurrentProfit
                                      )}
                                    </p>
                                    <p>
                                      <strong className="me-2">
                                        Total Lot:
                                      </strong>
                                      <NumericFormat
                                        displayType="text"
                                        value={account.TotalLot}
                                        thousandSeparator=","
                                        decimalScale={2}
                                      />
                                    </p>
                                    <p>
                                      <strong className="me-2">
                                        Profit Today:
                                      </strong>
                                      $
                                      {showCurrency(
                                        account.AccountNo,
                                        account.ProfitToday
                                      )}
                                    </p>
                                    <p>
                                      <strong className="me-2">
                                        Profit Yesterday:
                                      </strong>
                                      $
                                      {showCurrency(
                                        account.AccountNo,
                                        account.ProfitYesterday
                                      )}
                                    </p>
                                    <p>
                                      <strong className="me-2">
                                        Profit Current Month:
                                      </strong>
                                      $
                                      {showCurrency(
                                        account.AccountNo,
                                        account.ProfitCurrentMonth
                                      )}
                                    </p>
                                    <p>
                                      <strong className="me-2">
                                        Drawdown:
                                      </strong>
                                      <NumericFormat
                                        displayType="text"
                                        value={account.DrawdownPercent}
                                        thousandSeparator=","
                                        suffix="%"
                                        decimalScale={2}
                                      />
                                    </p>

                                    <p>
                                      <strong className="me-2">
                                        Grid Size:
                                      </strong>
                                      <NumericFormat
                                        displayType="text"
                                        value={account.GridSize}
                                        thousandSeparator=","
                                        decimalScale={2}
                                      />
                                    </p>
                                  </Card.Body>
                                  <Card.Footer>
                                    <Button
                                      variant="link"
                                      className={customTextDisplay}
                                      onClick={() =>
                                        toggleDetails(account.AccountNo)
                                      }
                                      aria-controls={`collapse-${account.AccountNo}`}
                                      aria-expanded={
                                        openDetails[account.AccountNo] || false
                                      }
                                    >
                                      View Details
                                    </Button>
                                  </Card.Footer>
                                  <Collapse in={openDetails[account.AccountNo]}>
                                    <div id={`collapse-${account.AccountNo}`}>
                                      <Card.Body>
                                        <p>
                                          <strong className="me-2">
                                            Points to Wipeout:
                                          </strong>
                                          <NumericFormat
                                            displayType="text"
                                            value={account.PointsToWipeout}
                                            thousandSeparator=","
                                            decimalScale={2}
                                          />
                                          <ul>
                                            <li>
                                              <strong className="me-2">
                                                1000 Points:
                                              </strong>
                                              <NumericFormat
                                                displayType="text"
                                                value={showCurrency(
                                                  account.AccountNo,
                                                  account.TotalLot * 1000
                                                )}
                                                thousandSeparator=","
                                                prefix="$"
                                                decimalScale={2}
                                              />
                                              <NumericFormat
                                                displayType="text"
                                                value={
                                                  showCurrency(
                                                    account.AccountNo,
                                                    account.TotalLot * 1000
                                                  ) * exchangeRate
                                                }
                                                prefix=" (~฿"
                                                suffix=")"
                                                thousandSeparator=","
                                                decimalScale={2}
                                              />
                                            </li>
                                            <li>
                                              <strong className="me-2">
                                                10000 Points:
                                              </strong>
                                              <NumericFormat
                                                displayType="text"
                                                value={showCurrency(
                                                  account.AccountNo,
                                                  account.TotalLot * 10000
                                                )}
                                                thousandSeparator=","
                                                prefix="$"
                                                decimalScale={2}
                                              />

                                              <NumericFormat
                                                displayType="text"
                                                value={
                                                  showCurrency(
                                                    account.AccountNo,
                                                    account.TotalLot * 10000
                                                  ) * exchangeRate
                                                }
                                                prefix=" (~฿"
                                                suffix=")"
                                                thousandSeparator=","
                                                decimalScale={2}
                                              />
                                            </li>
                                          </ul>
                                          <p></p>
                                        </p>
                                        <p>
                                          <strong className="me-2">
                                            Equity:
                                          </strong>
                                          <NumericFormat
                                            displayType="text"
                                            value={showCurrency(
                                              account.AccountNo,
                                              account.Equity
                                            )}
                                            thousandSeparator=","
                                            decimalScale={2}
                                          />
                                        </p>
                                        <p>
                                          <strong className="me-2">
                                            Wipeout Price:
                                          </strong>
                                          <NumericFormat
                                            displayType="text"
                                            value={parseFloat(
                                              account.WipeoutPrice
                                            )}
                                            prefix="$"
                                            thousandSeparator=","
                                            decimalScale={2}
                                          />
                                        </p>
                                      </Card.Body>
                                      <Card.Footer
                                        className={customTextDisplay}
                                      >
                                        Last Update: {account.LastUpdate}
                                      </Card.Footer>
                                    </div>
                                  </Collapse>
                                </Card>
                              </Col>
                            );
                          }
                        )}
                      </Row>
                    </Card.Body>
                  </Card>
                </Tab.Pane>
              ))}
            </Tab.Content>
          </Col>
        </Row>
      </Tab.Container>
    </Container>
  );
}

export default TradeDashboard;
